import * as React from 'react'

import { SkuInfoBlock } from "@components"
import { useBuildExternalURL } from "@hooks"


export default function skuColumn() {
	return {
		name: 'skuName', label: 'Product Name',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { category, brand, ean, siteID, asin, date, reference }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID, asin } })

				return <SkuInfoBlock
					sku={value}
					category={category}
					brand={brand}
					ean={ean}
					reference={reference}
					productURL={productURL}
				/>
			}
		}
	}
}